import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import classNames from 'clsx';
import type { TableProps } from 'react-aria-components';
import { Table as AriaTable } from 'react-aria-components';

import styles from './Table.module.scss';

export type Props = Pick<
  TableProps,
  | 'children'
  | 'className'
  | 'slot'
  | 'aria-label'
  | 'aria-labelledby'
  | 'aria-describedby'
  | 'aria-details'
> &
  VariantProps<typeof tableVariant>;

const tableVariant = cva(styles.container, {
  variants: {
    fitContent: {
      true: styles.fitContent
    }
  }
});

const Table = ({ className, fitContent, ...props }: Props) => (
  <AriaTable {...props} className={classNames(tableVariant({ fitContent }), className)} />
);

export default Table;
